import React from "react";
import styled from "styled-components";
import {Cell} from "./Cell";
import {benchmarkWidth} from "./Benchmark";
import {kpiWidth} from "./PortfolioKpi";
import {investmentWidth} from "./Investment";
import {pricesWidth} from "./StartPrice";

const Container = styled(Cell)`
    flex-basis: ${(benchmarkWidth + investmentWidth + pricesWidth + kpiWidth + 9) + "px"};
    justify-content: center;
    margin-right: 12px;
    flex-grow: 4;
`;


export const DescriptionCell = ({state}) => {
    return <Container className="t-description">
        {getStateDescription(state)}
    </Container>;
};

const getStateDescription = (state) => {
    switch (state) {
        case "notSent":
            return "Idea not sent";
        case "closed":
            return "Closed";
        default:
            return state;
    }
};